let snackbarRef;

export const setSnackbarRef = (enqueueSnackbar) => {
    snackbarRef = enqueueSnackbar;
};

export const showSnackbar = (message, variant = "success", options = {}) => {
    if (snackbarRef) {
        snackbarRef(message, {
            variant,
            ...options // Передаём кастомные стили
        });
    } else {
        console.warn("Snackbar не инициализирован!");
    }
};